import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { expand } from 'uri-template-lite';
import { DataObjectVersionUrl } from './DataObjectVersionUrls';
import { DataObjectVersionMetadataVersionSchema } from './DataObjectVersionMetadataVersionSchema';

const getDataObjectVersionMetadataVersions = ({
  id,
  type,
}: {
  id: number;
  type: string;
}) =>
  apiClient
    .get(expand(DataObjectVersionUrl.METADATA_VERSIONS, { id }), {
      params: { type },
    })
    .then((response) =>
      DataObjectVersionMetadataVersionSchema.array().parse(response.data),
    );

export const useDataObjectVersionMetadataVersionsQuery = createApiQueryHook(
  ['dataObjectVersionMetadataVersions'],
  getDataObjectVersionMetadataVersions,
);
